// ~/plugins/audio-player.client.ts

import AudioPlayer from 'vue3-audio-player'
import 'vue3-audio-player/dist/style.css' // Import the default styles

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('AudioPlayer', AudioPlayer)
})
